__turbopack_context__.v({
  "icon": "PortalSectionSearch-module__OzR57G__icon",
  "indicator": "PortalSectionSearch-module__OzR57G__indicator",
  "search": "PortalSectionSearch-module__OzR57G__search",
  "search-spin": "PortalSectionSearch-module__OzR57G__search-spin",
  "spinner": "PortalSectionSearch-module__OzR57G__spinner",
  "status": "PortalSectionSearch-module__OzR57G__status",
});
